export default class CountryStateFormFieldController {
    constructor() {
        this.DOM = {
            countryField: '.js-country-select-field',
            stateField: '.js-country-state-field',
        }

        this.countryField = document.querySelector(this.DOM.countryField);
        this.stateField = document.querySelector(this.DOM.stateField);
    }

    init() {
        this.initEvent();
        this.changeCountryEvent();
    }

    initEvent() {
        if (this.countryField) {
            let selectedOption = this.countryField.selectedOptions;

            if (selectedOption[0]) {
                this.showStateField(selectedOption[0].value);
            }
        }
    }

    changeCountryEvent() {
        if (this.countryField) {
            this.countryField.addEventListener('change', (event) => {
                event.preventDefault();

                let currentOption = event.currentTarget;
                let selectedOption = currentOption.selectedOptions;

                // console.log(selectedOption[0].value)

                if (selectedOption) {
                    this.showStateField(selectedOption[0].value);
                }
            });
        }
    }

    showStateField(option) {
        if (this.stateField) {
            if (!option) {
                this.stateField.style.display = 'none';
            }

            switch (option) {
                case 'united-states':
                case 'canada':
                    this.stateField.style.display = 'block';
                    return;
            }

            this.stateField.style.display = 'none';
        }
    }
}
